<template lang="html">
  <div class="not-found-wrapper">
    <v-container class="pt-0">
      <v-row justify="center">
        <v-col cols="12" sm="8" md="6" lg="4" class="text-center">
          <div class="icon-wrapper mb-6">
            <img src="@/assets/images/v2/img/table_not_found.png" :alt="$t('v2.table_not_found')">
          </div>

          <div class="mx-auto mb-6" style="max-width: 280px;">
            <!-- Judul -->
            <h2 class="font-weight-bold font-18 mb-2">
              {{ $t('v2.qr_not_valid') }}
            </h2>

            <!-- Deskripsi -->
            <p class="text-body-1">
              {{ $t('v2.try_scanning_another_table') }}
            </p>
          </div>

          <!-- Tombol -->
          <v-btn
            color="v2_primary"
            height="40"
            class="br-5 text-none white--text font-weight-bold btn-v2-shadow mb-8"
            @click="goBack()"
          >
            Laman utama
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'TableNotFound',
  methods: {
    goBack() {
      this.$router.push({ name: '_splash' })
    }
  }
}
</script>

<style scoped>
.not-found-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
}
</style>

